module.exports = __webpack_public_path__ + "assets/clear_search_old-ee43d8.svg";